<template>
  <Modal
    ref="cancelModalRef"
    type="info"
    :show-icon="true"
    negative-action-text="Sözleşmeye Geri Dön"
    positive-action-text="Evet"
    :modal-style="{ width: '600px' }"
    class="wms-agreement-cancel-modal"
    @on-negative-action-click="handleBack"
    @on-positive-action-click="handleConfirm"
  >
    <template #body>
      <div class="wms-agreement-cancel-modal-content">
        <p>
          Sözleşmeyi onaylamadığınız durumda n11 Depom'a erişemez ve ilgili
          fırsatlardan yararlanamazsınız.
        </p>
        <p>Vazgeçmek istediğinize emin misiniz?</p>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { ref } from 'vue';
import { Modal } from '@n11/so-ui-components';

const emit = defineEmits(['back', 'confirm']);

const cancelModalRef = ref(null);

const openModal = () => {
  cancelModalRef.value?.openModal();
};

const closeModal = () => {
  cancelModalRef.value?.hiddenModal();
};

const handleBack = () => {
  closeModal();
  emit('back');
};

const handleConfirm = () => {
  closeModal();
  emit('confirm');
};

defineExpose({ openModal, closeModal });
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.wms-agreement-cancel-modal {
  :deep(.modal-wrapper .modal-container .modal-body) {
    padding: 10px;
  }

  :deep(
      .modal-mask
        .modal-wrapper
        .modal-container
        .modal-header
        .modal-close-icon
    ) {
    right: 24px;
  }

  :deep(.modal-footer #negative-button),
  :deep(.modal-footer #positive-button) {
    height: 48px !important;
    font-size: 16px !important;
    padding: 0 24px !important;
    letter-spacing: -0.11px;
  }
}

.wms-agreement-cancel-modal-content {
  display: flex;
  flex-direction: column;
  gap: 26px;

  p {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
    color: $colorN80;
    text-align: center;
    letter-spacing: -0.2px;
  }
}
</style>
